/** Multiply two numbers */
export default function mul(a: number, b: number) {
  return a * b;
}
